import { useState } from 'react'
import css from './TableImage.module.scss'

// type: rect / circle

export default function TableImage({
	src,
	alt,
	type = 'rect',
	iconUnicode = '',
	boxStyles,
	size = '64px',
	imageStyles = {},
}) {
	const [imageIsValid, setImageIsValid] = useState(src)

	function handleOnError() {
		setImageIsValid(false)
	}

	return (
		// <object
		//    data={src}
		//    type="image/png"
		//    width="64"
		//    height="64"
		// >
		<div
			className={`${css['box']} ${css[type]} ${imageIsValid ? '' : css['no-image']}`}
			data-icon={iconUnicode}
			style={{ '--size': size, ...boxStyles }}>
			{/* {imageIsValid ? "yes" : "no"} */}
			<img
				src={src}
				className={css['image']}
				alt={alt}
				height={size}
				width={size}
				onError={handleOnError}
				style={{ ...imageStyles }}
			/>
		</div>
		// </object>
	)
}
